import { format, formatDistanceToNow, isToday, isYesterday, parseISO } from "date-fns";

export function formatMessageTime(dateString: string): string {
  const date = parseISO(dateString);
  return format(date, "h:mm a");
}

export function formatTaskDate(dateString: string): string {
  const date = parseISO(dateString);
  return format(date, "d MMM yyyy");
}

/**
 * Formats a date with day name, ordinal day, and month (e.g., "Mon 24th Jan" or "Tues 21st Jan, 2026")
 * Includes year if the date is not in the current year
 */
export function formatDateWithDay(dateString: string | Date): string {
  const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
  const day = date.getDate();
  
  // Get ordinal suffix
  const getOrdinalSuffix = (n: number): string => {
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  };
  
  const ordinalSuffix = getOrdinalSuffix(day);
  const dayName = format(date, "EEE"); // Mon, Tue, Wed, etc.
  const month = format(date, "MMM"); // Jan, Feb, etc.
  
  // Check if year is needed (not current year)
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();
  const yearSuffix = dateYear !== currentYear ? `, ${dateYear}` : '';
  
  return `${dayName} ${day}${ordinalSuffix} ${month}${yearSuffix}`;
}

export function formatRelativeTime(dateString: string): string {
  const date = parseISO(dateString);
  return formatDistanceToNow(date, { addSuffix: true });
}

export function formatDueDate(dateString: string): string {
  const date = parseISO(dateString);
  return format(date, "d MMM");
}

export function getDateDivider(dateString: string): string {
  const date = parseISO(dateString);
  
  if (isToday(date)) {
    return "Today";
  }
  
  if (isYesterday(date)) {
    return "Yesterday";
  }
  
  return format(date, "d MMMM yyyy");
}

export function shouldShowDateDivider(
  currentMessageDate: string,
  previousMessageDate?: string
): boolean {
  if (!previousMessageDate) return true;
  
  const current = parseISO(currentMessageDate);
  const previous = parseISO(previousMessageDate);
  
  return current.toDateString() !== previous.toDateString();
}
